import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FontAwesomeModule, type IconDefinition } from '@fortawesome/angular-fontawesome';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

export type LabelColorOptions = 'primary' | 'positive' | 'negative' | 'progress' | 'severe' | 'neutral' | 'ai';

@Component({
  selector: 'rcp-label',
  template: `
    <span
      class="rcp-label "
      [class.primary]="color() === 'primary'"
      [class.positive]="color() === 'positive'"
      [class.negative]="color() === 'negative'"
      [class.progress]="color() === 'progress'"
      [class.ai]="color() === 'ai'"
      [class.severe]="color() === 'severe'"
      [class.neutral]="color() === 'neutral'"
      [class.clickable]="clickable()"
      [class.as-badge]="hideLabelTextOnSmallScreens()"
    >
      <span class="label-detail">
        <span class="label-detail-wrapper">
          <ng-content select="[label-detail]"></ng-content>
        </span>
        @if (icon()) {
          <fa-icon [icon]="icon()"></fa-icon>
        }
      </span>
      <span class="label-text text ellipsis" [class.hide-tiny]="hideLabelTextOnSmallScreens()">
        <ng-content></ng-content>
      </span>
      @if (asDropdown()) {
        <fa-icon [icon]="faChevronDown"></fa-icon>
      }
    </span>
  `,
  styleUrls: ['./label.component.scss'],
  imports: [FontAwesomeModule],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class LabelComponent {
  clickable = input<boolean>(false);
  icon = input<IconProp | IconDefinition>();
  color = input<LabelColorOptions>('primary');
  hideLabelTextOnSmallScreens = input<boolean>();
  asDropdown = input<boolean>(false);
  protected readonly faChevronDown = faChevronDown;
}
